export function cleanText(s: string, max = 500): string {
  return s.replace(/[<>]/g, '').trim().slice(0, max);
}

export function normalizePhone(s: string): string {
  return s.replace(/\D/g, '');
}

export function isValidName(s: string): boolean {
  const t = s.trim();
  return t.length >= 2 && t.length <= 80 && /^[\p{L}\s'.-]+$/u.test(t);
}

export function isValidPhone(s: string): boolean {
  const d = normalizePhone(s);
  return d.length >= 8 && d.length <= 13;
}

export function isValidEmail(s: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(s.trim());
}

/** Valida CUIL/CUIT argentino (11 dígitos, prefijo y dígito verificador). */
export function isValidCuil(s: string): boolean {
  const d = s.replace(/\D/g, '');
  if (d.length !== 11) return false;
  if (!['20', '23', '24', '27', '30', '33', '34'].includes(d.slice(0, 2))) return false;
  const weights = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
  const sum = weights.reduce((acc, w, i) => acc + w * Number(d[i]), 0);
  let check = 11 - (sum % 11);
  if (check === 11) check = 0;
  if (check === 10) check = 9;
  return check === Number(d[10]);
}

export function formatCuil(s: string): string {
  const d = s.replace(/\D/g, '').slice(0, 11);
  if (d.length <= 2) return d;
  if (d.length <= 10) return `${d.slice(0, 2)}-${d.slice(2)}`;
  return `${d.slice(0, 2)}-${d.slice(2, 10)}-${d.slice(10)}`;
}

export function buildWhatsAppUrl(number: string, text: string): string {
  return `https://wa.me/${normalizePhone(number)}?text=${encodeURIComponent(text)}`;
}
